import { Button, Image } from "@atoms";
import { AuthSection } from "@organisms";
import { useTranslation } from "react-i18next";

export type SentPageTemplateProps = {
  handleBackButtonClick: () => void;
  handleSendEmailClick: () => void;
};

export const SentPageTemplate = ({
  handleBackButtonClick,
  handleSendEmailClick,
}: SentPageTemplateProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex">
      <AuthSection />

      {/* Right side - Content */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8 text-center items-center justify-center">
          <div className="mb-7 place-self-center">
            <Image variant="horns" />
          </div>
          <div className="mb-6 place-self-center">
            <h3 className="text-3xl font-black text-neutral-darkest">{t("auth.requestSent.title")}</h3>
          </div>
          <h3 className="text-lg text-gray-500 mb-4 place-self-center">
            {t("auth.requestSent.description")}
          </h3>
          <div className="flex justify-center items-center mb-16 place-self-center">
            <h3 className="text-lg text-gray-500 mr-2">{t("auth.requestSent.questions")}</h3>
            <Button
              variant="link"
              label={t("auth.requestSent.sendEmail")}
              onClick={handleSendEmailClick}
              className="text-lg font-normal text-brand-orange underline hover:text-primary-dark"
            />
          </div>
          <div className="place-self-center">
            <Button
              variant="primary"
              label={t("auth.common.backToHome")}
              color="neutral-darkest"
              hoverColor="neutral-dark"
              textColor="white"
              onClick={handleBackButtonClick}
              size="sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
